import React from 'react';

const MyItems = () => {
    return (
        <div>
            <h3>this is for my items</h3>
        </div>
    );
};

export default MyItems;